import { makeApiCall } from '../_common/api.utils';
import { API_URL } from '../config';

export const getAllCompOffByOrg = async (data: any) => {
	const URL = `${API_URL}GetAllCompOffByOrg`;
	const requestData = {
		GetAllCompOffByOrgToken: data,
	};
	return makeApiCall(URL, requestData);
};
